import { types } from 'mobx-state-tree';

export const FormulaModel = types.model('FormulaModel', {
  feature: types.string,
});
